import React from 'react';

const StatusMessage = ({ status, error }) => {
  if (!status && !error) return null;
  
  if (status) {
    return (
      <p className="bg-green-300 font-lufga rounded-md shadow-md px-2 py-1 text-xs text-center">
        {status}
      </p>
    );
  }
  
  if (error) {
    return (
      <p className="bg-red-300 font-lufga rounded-md text-center shadow-md px-2 py-1 text-xs">
        {typeof error === 'string' 
          ? error 
          : Object.keys(error).map(key => 
              Array.isArray(error[key]) ? error[key][0] : error[key]
            )
        }
      </p>
    );
  }
  
  return null;
};

export default StatusMessage; 